// Vendor
import $ from 'jquery';
import Stickyfill from 'stickyfilljs';

// Elements
let $el = $('nav');

class Nav {
	constructor(el) {

		this.navSearchOpen = false;
		this.mobileMenuOpen = false;

		// Elements
		this.$el = $(el);
		this.$searchButton = this.$el.find('.nav-search-toggle');
		this.$searchBar = this.$el.find('.nav-search');
		this.$mobileMenuButton = $('.nav-mobile-menu-toggle');
		this.$mobileMenu = $('.nav-mobile-menu');
		this.$searchSubmit = this.$el.find('.nav-search-submit');

		// Classes
		this.searchOpenClass = 'is-open';
		this.navSearchOverlayClass = 'nav-search-overlay';
		this.mobileMenuOpenClass = 'is-open';
		this.mobileMenuOverlayClass = 'nav-mobile-menu-overlay';

		this.attachEvents();
	}

	attachEvents(){

		//bind nav search dropdown button
		this.$searchButton.on('click', () => {
			this.toggleNavSearch();
		});

		//bind nav search toggle to overlay
		$('body').on('click', '.'+this.navSearchOverlayClass, () =>{
			this.toggleNavSearch();
		});

		//bind nav search dropdown button
		this.$mobileMenuButton.on('click', () => {
			this.toggleMobileMenu();
		});
		//bind nav search toggle to overlay
		let action = (window.Modernizr.touch) ? 'touchend' : 'click';
		$('body').on(action, '.'+this.mobileMenuOverlayClass, () =>{
			this.toggleMobileMenu();
		});

		//scroll for nav shrink/expand
		$(window).scroll(()=>{
			this.navShrinkExpand();
		});

		// sticky polyfill
		var elements = $('.sticky');
		Stickyfill.add(elements);

	}

	navShrinkExpand() {
		let scrollTop = $(document).scrollTop();

		//expand width of nav
		if ( scrollTop > 0 ) {
			this.$el.addClass('expand');
		} else {
			this.$el.removeClass('expand');
		}

		//shrink/hide top nav
		if ( scrollTop <= 0 || this.previousScrollTop && this.previousScrollTop > scrollTop ) {
			//scrolled up
			this.$el.removeClass('shrink');
		} else {
			//scrolled down
			this.$el.addClass('shrink');
		}

		this.previousScrollTop = scrollTop;
	}

	toggleNavSearch(){
		if ( !this.navSearchOpen ) {
			//open search bar
			this.navSearchOpen = true;

			//create and fade in overlay
			$('body').append('<div class="overlay '+this.navSearchOverlayClass+'"></div>');
			$('.'+this.navSearchOverlayClass).last().fadeIn();

			//toggle search bar btn and bar
			this.$searchButton.addClass(this.searchOpenClass);
			this.$searchBar.fadeIn();
		} else {
			//close search bar
			this.navSearchOpen = false;

			//fade out and remove overlay
			$('.'+this.navSearchOverlayClass).fadeOut(function(){
				$(this).remove();
			});

			//toggle search bar btn and bar
			this.$searchButton.removeClass(this.searchOpenClass);
			this.$searchBar.fadeOut();
		}
	}

	toggleMobileMenu(){
		if ( !this.mobileMenuOpen ) {
			//open mobile menu
			this.mobileMenuOpen = true;

			//create and fade in overlay
			$('nav.nav-mobile').append('<div class="overlay '+this.mobileMenuOverlayClass+'"></div>');
			$('.'+this.mobileMenuOverlayClass).last().fadeIn();

			//toggle mobile menu btn and menu
			this.$mobileMenuButton.addClass(this.mobileMenuOpenClass);
			this.$mobileMenu.addClass(this.mobileMenuOpenClass);
		} else {
			//close mobile bar
			this.mobileMenuOpen = false;

			//fade out and remove overlay
			$('.'+this.mobileMenuOverlayClass).fadeOut(function(){
				$(this).remove();
			});

			//toggle mobile menu btn and menu
			this.$mobileMenuButton.removeClass(this.mobileMenuOpenClass);
			this.$mobileMenu.removeClass(this.mobileMenuOpenClass);
		}
	}

}

export default Nav;

const _init = () => {
	if ($el.length) {
		new Nav($el);
	}
};

_init();
